import React__default, { memo } from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { Button } from '../Button/index.js';
import { Lightbox } from '../Lightbox/index.js';
import { Square } from '../Square/index.js';
import styles from 'ui-components/ProductViewMedia.scss';

var DefaultCloseIcon = function DefaultCloseIcon() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "16",
    height: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M11.6 4.4l-7.2 7.2M11.6 11.6L4.4 4.4"
  })));
};
var GalleryLightbox = function GalleryLightbox(_ref) {
  var gallery = _ref.gallery,
    alt = _ref.alt,
    lightboxImage = _ref.lightboxImage,
    setLightboxImage = _ref.setLightboxImage,
    open = _ref.open,
    setOpen = _ref.setOpen,
    _ref$CloseIcon = _ref.CloseIcon,
    CloseIcon = _ref$CloseIcon === void 0 ? DefaultCloseIcon : _ref$CloseIcon;
  var t = useTranslate();
  if (!lightboxImage) {
    return null;
  }
  var largeImage = lightboxImage.largeImage || {
    x1: "",
    x2: ""
  };
  return /*#__PURE__*/React__default.createElement(Lightbox, {
    open: open,
    setOpen: setOpen,
    variant: "fullscreen"
  }, /*#__PURE__*/React__default.createElement(Button, {
    type: "button",
    className: styles.lightboxClose,
    onClick: function onClick() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React__default.createElement(CloseIcon, {
    title: t("ICONS.CROSS")
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.lightbox
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.lightboxImageWrapper
  }, /*#__PURE__*/React__default.createElement("picture", {
    className: styles.lightboxImage
  }, /*#__PURE__*/React__default.createElement("source", {
    srcSet: largeImage.x1 + ", " + largeImage.x2 + " 2x",
    media: "(max-width: " + (parseInt(styles.breakpoint, 10) - 1) + "px)"
  }), /*#__PURE__*/React__default.createElement("source", {
    srcSet: largeImage.x1 + ", " + largeImage.x2 + " 2x",
    media: "(min-width: " + parseInt(styles.breakpoint, 10) + "px)"
  }), /*#__PURE__*/React__default.createElement("img", {
    alt: alt,
    src: largeImage.x2,
    style: {
      position: "absolute",
      width: "100%",
      zIndex: 2
    }
  })), /*#__PURE__*/React__default.createElement(Square, null)), /*#__PURE__*/React__default.createElement("div", {
    className: styles.lightboxGallery
  }, gallery.length > 1 && gallery.map(function (x) {
    var _x$thumb, _x$largeImage, _lightboxImage$largeI, _cn;
    return /*#__PURE__*/React__default.createElement(Button, {
      key: (_x$thumb = x.thumb) == null ? void 0 : _x$thumb.x1,
      className: cn(styles.lightboxGalleryItem, (_cn = {}, _cn[styles.active] = ((_x$largeImage = x.largeImage) == null ? void 0 : _x$largeImage.x1) === ((_lightboxImage$largeI = lightboxImage.largeImage) == null ? void 0 : _lightboxImage$largeI.x1), _cn)),
      "aria-label": t("PRODUCT.CHANGE_IMAGE"),
      onClick: function onClick() {
        var _x$largeImage2, _lightboxImage$largeI2;
        return ((_x$largeImage2 = x.largeImage) == null ? void 0 : _x$largeImage2.x1) !== ((_lightboxImage$largeI2 = lightboxImage.largeImage) == null ? void 0 : _lightboxImage$largeI2.x1) && setLightboxImage({
          tinyImage: x.tinyImage ? {
            x1: x.tinyImage.x1,
            x2: x.tinyImage.x2
          } : null,
          smallImage: x.smallImage ? {
            x1: x.smallImage.x1,
            x2: x.smallImage.x2
          } : null,
          mediumImage: x.mediumImage ? {
            x1: x.mediumImage.x1,
            x2: x.mediumImage.x2
          } : null,
          largeImage: x.largeImage ? {
            x1: x.largeImage.x1,
            x2: x.largeImage.x2
          } : null
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, x.thumb && /*#__PURE__*/React__default.createElement("picture", null, /*#__PURE__*/React__default.createElement("source", {
      srcSet: x.thumb.x1 + " 1x, " + x.thumb.x2 + " 2x"
    }), /*#__PURE__*/React__default.createElement("img", {
      alt: alt,
      src: x.thumb.x1
    }))));
  }))));
};
var GalleryLightbox$1 = /*#__PURE__*/memo(GalleryLightbox, function (prev, next) {
  var _prev$lightboxImage, _next$lightboxImage;
  if (prev.open !== next.open) {
    return false;
  }
  if (((_prev$lightboxImage = prev.lightboxImage) == null || (_prev$lightboxImage = _prev$lightboxImage.largeImage) == null ? void 0 : _prev$lightboxImage.x1) !== ((_next$lightboxImage = next.lightboxImage) == null || (_next$lightboxImage = _next$lightboxImage.largeImage) == null ? void 0 : _next$lightboxImage.x1)) {
    return false;
  }
  return true;
});

export default GalleryLightbox$1;
//# sourceMappingURL=gallery-lightbox.js.map
